import { Form, Input } from "antd";
import type { Rule } from "rc-field-form/lib/interface";
// import { PREFIXES } from "../../constants/app";

type PhoneNumberInputProps = {
  name: string,
  label: string,
  rules?: Rule[]
};

const PhoneNumberInput = ({
  name, label, rules
}:PhoneNumberInputProps) => {
  // const prefixSelector = (
  //   <Form.Item name={[name, "prefix"]} noStyle>
  //     <Select
  //       style={{ width: 70 }}
  //       options={PREFIXES}
  //     />
  //   </Form.Item>
  // );

  return (
    <Form.Item
      label={label}
      rules={rules}
    >
      <Form.Item
        name={[name, "number"]}
        noStyle
        rules={rules}
      >
        <Input
          // addonBefore={prefixSelector}
          style={{ width: "100%" }}
        />
      </Form.Item>
    </Form.Item>
  );
};

export default PhoneNumberInput;
